/*
 * Prefills the review-feedback page from the order-rating email's link.
 *
 *   /pages/review?order=BF3279187&rating=2
 *
 * Fills the order/rating line and rewrites the mailto so support opens the
 * message already knowing which order and how it was rated. Progressive
 * enhancement only: the page and its plain mailto work without this file.
 */
(function () {
  var i18nEl = document.querySelector("[data-gb-review-i18n]");
  if (!i18nEl) return;

  var t;
  try {
    t = JSON.parse(i18nEl.textContent);
  } catch (e) {
    return;
  }

  // Liquid's `t` filter HTML-escapes translations and a JSON parser does not undo
  // entities, so the Italian "Feedback sull'ordine" arrives as sull&#39;ordine and
  // would reach the mailto subject spelled that way. Decoding here rather than
  // renaming the keys to *_html keeps it right for every entity a translator can
  // introduce - apostrophes, quotes, ampersands - in any of the 13 locales.
  function decodeEntities(value) {
    var scratch = document.createElement("textarea");
    scratch.innerHTML = value;
    return scratch.value;
  }

  Object.keys(t).forEach(function (key) {
    t[key] = decodeEntities(t[key]);
  });

  var params = new URLSearchParams(window.location.search);
  var order = (params.get("order") || "").trim();
  var rating = (params.get("rating") || "").trim();

  // Both values are echoed into the page and into a mailto, so anything that is
  // not the shape we send is treated as absent rather than reflected back.
  if (!/^[1-5]$/.test(rating)) rating = "";
  if (!/^[A-Za-z0-9_-]{1,32}$/.test(order)) order = "";

  // Nothing usable on the query string: leave the page exactly as rendered.
  if (!rating) return;

  function fill(template) {
    return template.split("{order}").join(order).split("{rating}").join(rating);
  }

  var metaEl = document.querySelector("[data-gb-review-meta]");
  if (metaEl) {
    metaEl.textContent = order ? fill(t.meta) : fill(t.meta_rating);
    metaEl.hidden = false;
  }

  var mailEl = document.querySelector("[data-gb-review-mail]");
  if (mailEl) {
    // Drop the order line wholesale when there is no order, rather than leaving
    // a dangling label. Works for any language because it keys on the token.
    var bodyTemplate = t.mail_body;
    if (!order) {
      bodyTemplate = bodyTemplate
        .split("\n")
        .filter(function (line) {
          return line.indexOf("{order}") === -1;
        })
        .join("\n");
    }

    mailEl.href =
      mailEl.href.split("?")[0] +
      "?subject=" +
      encodeURIComponent(fill(t.mail_subject)) +
      "&body=" +
      encodeURIComponent(fill(bodyTemplate));
  }
})();
